import React, { useEffect } from 'react';

import { Translation, getI18n } from 'react-i18next';
import { pathTo } from '../../../Routes';
import { Button } from 'antd';
import notification from '../../../elements/lib/NotificationWrapper';

const CognitoFormForm = ({
  cognitoId,
  cognitoKey,
  profileId,
  newUserRequirement,
  careGuideId,
  cognitoFormId,
  oldUserRequirement,
  history,
  isOldUser,
  ...props
}) => {
  const handleSkip = () => {
    props.create(careGuideId, { cognito_form_id: cognitoFormId }, (success) => {
      if (success) {
        notification.success(getI18n().t('skip_cognito_form_success'));
      } else {
        notification.error(getI18n().t('skip_cognito_form_error'));
      }
    });

    history.push(
      pathTo(
        'DashboardDetailScreen',
        { id: careGuideId },
        {
          rct: 'form',
        }
      )
    );
  };

  useEffect(() => {
    if (!cognitoId || !cognitoKey) return;

    const script = document.createElement('script');
    script.src = 'https://www.cognitoforms.com/f/seamless.js';
    script.dataset.key = cognitoKey;
    script.dataset.form = cognitoId;
    script.async = true;

    script.onload = () => {
      if (window.Cognito) {
        window.Cognito.mount(cognitoId, '#cognito')
          .prefill({
            UserProfileId: profileId,
          })
          .on('afterSubmit', function (e) {
            history.push(
              pathTo(
                'DashboardDetailScreen',
                { id: careGuideId },
                {
                  rct: 'form',
                }
              )
            );
          });
      }
    };
    document.getElementById('cognito').appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cognitoId, cognitoKey]);

  return (
    <Translation>
      {(t) => (
        <div className='register-form-register-form-step4'>
          <div style={{ backgroundColor: 'white', padding: '10px' }}>
            <div id='cognito'></div>
            {((newUserRequirement === 2 && !isOldUser) ||
              (oldUserRequirement && isOldUser)) && (
              <div style={{ width: '100%' }}>
                <Button type='default' size='large' block onClick={handleSkip}>
                  {t('cognito_forms_screen_skip')}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </Translation>
  );
};

export default CognitoFormForm;
